import { render, staticRenderFns } from "./BrandDashboard.vue?vue&type=template&id=15a4dc3c&scoped=true"
import script from "./BrandDashboard.vue?vue&type=script&lang=js"
export * from "./BrandDashboard.vue?vue&type=script&lang=js"
import style0 from "./BrandDashboard.vue?vue&type=style&index=0&id=15a4dc3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4dc3c",
  null
  
)

export default component.exports